export default __webpack_public_path__ + "static/media/F4267D37-5E0B-4F6A-A4CF-70643B13CB41.04158545.jpeg";